import React, { useCallback, useState, useRef } from 'react';
import chunk from 'lodash-es/chunk';
import { IconButton } from '@material-ui/core';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon
} from '@material-ui/icons';
import { visibleDays, getYearMonthDate, getYearMonthKor, getDate } from '../calendar';
import DayView from './DayView';
import MemoDialog from './MemoDialog';
import styles from './SettlementCalendar.module.css';
import { Actions, Resources, useHasPermissions } from '../lib/react-admin-loopback';

const findSettlementByDate = (data, date) => {
  if (!data) return null;

  const ymd = getYearMonthDate(date);
  return data.settlement.find(el => el.date === ymd);
}

const SettlementCalendar = (props) => {
  const { firstDate, data, 
    onClickPrev, onClickNext, onSaveMemo } = props;
    
  const hasPermission = useHasPermissions(
    Resources.SupplierOrders,
    Actions.Show,
    () => {
      alert('권한이 없습니다.');
      props.history.push('/sp-stlist');
    }
  );

  // get dates of month, weeks 
  const datesOfMonth = visibleDays(firstDate);
  const weeks = chunk(datesOfMonth, 7);

  // 다이얼로그 선택된 date 정보 
  const selectedDate = useRef();

  const [ open, setOpen ] = useState(false);
  const [ memo, setMemo ] = useState({ adjust: 0, adjustMemo: null });

  const handleClickMemo = useCallback((evt) => {
    // set memo data to dialog 
    const ymd = evt.currentTarget.getAttribute('data-date');
    selectedDate.current = getDate(ymd);
    const selected = findSettlementByDate(data, selectedDate.current);
    setMemo({
      adjust: selected.adjust,
      adjustMemo: selected.adjustMemo
    });
    // open dialog 
    setOpen(true);
  }, [ data ]);

  const handleClose = () => {
    setOpen(false);
  }

  const handleSave = (memoToSave) => {
    setOpen(false);
    onSaveMemo(selectedDate.current, memoToSave);
  }

  return (
    <div className={styles.calendar}>
      <div>
        <span>{getYearMonthKor(firstDate)}</span>
        <IconButton
          aria-label="go to prev"
          onClick={onClickPrev}
        >
          <ChevronLeftIcon />
        </IconButton>
        <IconButton
          aria-label="go to next"
          onClick={onClickNext}
        >
          <ChevronRightIcon />
        </IconButton>
      </div>
      {/* week views */}
      <div>
      {weeks.map((week, i) => ( 
        <WeekView
          key={i}
          week={week}
          data={data}
          onClickMemo={handleClickMemo}
        />
      ))}
      </div>
      <MemoDialog
        open={open}
        memo={memo}
        onClose={handleClose}
        onSave={handleSave}
      />
    </div>
  );
}

const WeekView = ({ week, data, onClickMemo }) => {

  return (
    <div className={styles.weekRow}>
      {/* bg */}
      <div className={styles.weekRowBg}>
        {week.map((day, i) => (
          <div 
            key={i}
            className={styles.dayBg}
          />
        ))}
      </div>
      {/* header */}
      <div className={styles.weekHeaderRow}>
        {week.map((day, i) => (
          <div key={i.toString()} className={styles.weekHeader}>
            {day.getDate()}
          </div>
        ))}
      </div>
      {/* day views */}
      <div className={styles.dayRow}>
        {week.map((day, i) => (
          <div
            key={i}
            className={styles.dayView}
          >
            <DayView
              key={i}
              day={day}
              settlement={findSettlementByDate(data, day)}
              onClickMemo={onClickMemo}
            />
          </div>
        ))}
      </div>
      {/* footer */}
      <div>

      </div>
    </div>
  );
}

export default SettlementCalendar;